import { createDuoToneIcon } from './helpers/createDuoToneIcon'

export const CheckSuccessDuoTone = createDuoToneIcon(
  'CheckSuccessDuoTone',
  [
    [
      'path',
      {
        d: 'M12 1.625C14.2144 1.625 15.9637 1.62308 17.3291 1.80664C18.7194 1.99362 19.8423 2.38728 20.7275 3.27246C21.6127 4.15766 22.0064 5.2806 22.1934 6.6709C22.3769 8.03624 22.375 9.78557 22.375 12C22.375 14.2142 22.3769 15.9628 22.1934 17.3281C22.0181 18.6317 21.6611 19.7006 20.8877 20.5586L20.7275 20.7275C19.8422 21.6128 18.7186 22.0064 17.3281 22.1934C15.9628 22.3769 14.2142 22.375 12 22.375C9.78557 22.375 8.03624 22.3769 6.6709 22.1934C5.2806 22.0064 4.15766 21.6127 3.27246 20.7275C2.38728 19.8423 1.99362 18.7194 1.80664 17.3291C1.62308 15.9637 1.625 14.2144 1.625 12C1.625 9.78557 1.62307 8.03625 1.80664 6.6709C1.99362 5.28059 2.38727 4.15766 3.27246 3.27246C4.15766 2.38727 5.28059 1.99362 6.6709 1.80664C8.03625 1.62307 9.78557 1.625 12 1.625Z',
        stroke: 'none',
        key: 'CheckSuccessDuoTone-0',
      },
    ],
    [
      'path',
      {
        d: 'M14.3808 9.38092C14.7225 9.03921 15.2774 9.03921 15.6191 9.38092C15.9608 9.72262 15.9608 10.2775 15.6191 10.6192L11.6191 14.6192C11.2774 14.9609 10.7225 14.9609 10.3808 14.6192L8.38079 12.6192C8.03908 12.2775 8.03908 11.7226 8.38079 11.3809C8.7225 11.0392 9.27737 11.0392 9.61907 11.3809L10.9999 12.7618L14.3808 9.38092Z',
        stroke: 'none',
        key: 'CheckSuccessDuoTone-1',
      },
    ],
  ],
  {
    defaultGradient: 'green',
    defaultForegroundClassName: 'fill-background',
  },
)

CheckSuccessDuoTone.displayName = 'CheckSuccessDuoTone'
